import React from 'react';
import postal from 'postal';
import { useAppDispatch } from '../app/hooks';
import { showGlobalYesNoDialog } from '../features/globalYesNoDialogSlice';
import { formatDialogContent } from './dialogHelpers';

/**
 * useGlobalYesNoDialog - provides generic function for displaying Yes/No dialog
 *
 * @export
 * @return {*} 
 */
 export default function useGlobalYesNoDialog() {
  const dispatch = useAppDispatch();
  const channel = postal.channel('ajax');

  /**
   * showYesNoDialog - awaitable Promise to show global yes/no dialog. Result is true for Yes and false for No
   *
   * @param {(string|null)} [top=null] - use to override top position on the screen (middle of the screen by default)
   * @return {*} 
   */
   function showYesNoDialog(contentParam:string|React.ReactNode, invert?:boolean, focusindex?:number, addor?:boolean, type:'info'|'warning'='info') {
    return new Promise<boolean>(resolve => {
    channel.publish('ajax.loadingend', {});

      dispatch(showGlobalYesNoDialog({
        content: formatDialogContent(contentParam),
        resolve,
        invert:invert??false,
        focusindex:focusindex??0,
        addor:addor??false,
        type,
      }));
    })
  }

  return [showYesNoDialog];
}